import { Link } from "react-router-dom";
import logoSrc from "@/assets/upbrief-logo.svg";
import { cn } from "@/lib/utils";

type LogoSize = "sm" | "md" | "lg";

const sizeMap: Record<LogoSize, { icon: string; text: string; gap: string }> = {
  sm: { icon: "h-6 w-6", text: "text-base", gap: "gap-2" },
  md: { icon: "h-8 w-8", text: "text-xl", gap: "gap-2.5" },
  lg: { icon: "h-10 w-10", text: "text-2xl", gap: "gap-3" },
};

interface LogoProps {
  size?: LogoSize;
  showWordmark?: boolean;
  to?: string | null;
  className?: string;
}

export function Logo({ size = "md", showWordmark = true, to = "/", className }: LogoProps) {
  const s = sizeMap[size];
  const content = (
    <span className={cn("inline-flex items-center", s.gap, className)}>
      <img
        src={logoSrc}
        alt="Upbrief"
        className={cn(s.icon, "shrink-0 select-none")}
        draggable={false}
      />
      {showWordmark && (
        <span
          className={cn("font-display font-semibold lowercase tracking-tight", s.text)}
          style={{ color: "#0D3A27" }}
        >
          upbrief
        </span>
      )}
    </span>
  );
  if (to) {
    return (
      <Link to={to} className="inline-flex items-center">
        {content}
      </Link>
    );
  }
  return content;
}

export default Logo;